import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { Store } from './store.model';

import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class LanguageStore extends Store<string> {
    private _translate = inject(TranslateService);
    private _adapter = inject<DateAdapter<any>>(DateAdapter);

    private _localStorageKey = 'selectedLanguage';


    constructor() {
        super('sv_se');
    }

    public getState() {
        return super.state$;
    }

    public load() {
        const lang = localStorage.getItem(this._localStorageKey);
        if (lang) {
            this.setLanguage(lang);
        }
    }

    setLanguage(language: string) {
        this.setState(language);
        this._translate.use(language);

        moment.locale(language);
        this._adapter.setLocale(language);
        localStorage.setItem(this._localStorageKey, language);
    }
}
